/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { fromUtf8ToBase64 } from "@fluid-internal/client-utils";
export const getAuthorizationTokenFromCredentials = (credentials) => `Basic ${fromUtf8ToBase64(`${credentials.user}:${credentials.password}`)}`;
/**
 * Implementation of the IHistorian interface that calls out to a REST interface
 */
export class Historian {
    constructor(historianApi, disableCache, restWrapper) {
        this.historianApi = historianApi;
        this.restWrapper = restWrapper;
        this.defaultQueryString = {};
        if (disableCache && this.historianApi) {
            this.defaultQueryString.disableCache = disableCache;
            this.cacheBust = false;
        }
        else {
            this.cacheBust = disableCache;
        }
    }
    async getBlob(sha) {
        return this.restWrapper.get(`/git/blobs/${encodeURIComponent(sha)}`, this.getQueryString());
    }
    async createBlob(blob) {
        return this.restWrapper.post(`/git/blobs`, blob, this.getQueryString());
    }
    async getCommits(sha, count) {
        return this.restWrapper
            .get(`/commits`, this.getQueryString({ count, sha }))
            .catch(async (error) => error.statusCode === 400 || error.statusCode === 404
            ? {
                content: [],
                headers: new Map(),
                propsToLog: {},
                requestUrl: "",
            }
            : Promise.reject(error));
    }
    async createTree(tree) {
        return this.restWrapper.post(`/git/trees`, tree, this.getQueryString());
    }
    async getTree(sha, recursive) {
        return this.restWrapper.get(`/git/trees/${encodeURIComponent(sha)}`, this.getQueryString({ recursive: recursive ? 1 : 0 }));
    }
    async createSummary(summary, initial) {
        return this.restWrapper.post(`/git/summaries`, summary, this.getQueryString(initial !== undefined ? { initial } : undefined));
    }
    async getSnapshot(sha) {
        return this.restWrapper.get(`/git/summaries/${sha}`, this.getQueryString());
    }
    getQueryString(queryString) {
        if (this.cacheBust) {
            return {
                cacheBust: Date.now(),
                ...this.defaultQueryString,
                ...queryString,
            };
        }
        return {
            ...this.defaultQueryString,
            ...queryString,
        };
    }
}
//# sourceMappingURL=historian.js.map